import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useBeforeUnload } from "react-router-dom";
import { layers, Portal, ToastMessage } from "@activecollab/components";
import { clearHttpMessages } from "~/store/actions/actions.httpMessages.jsx";
import { getHttpMessageData } from "~/store/selectors/selector.httpMessages.jsx";
import Angie from "~/utils/angie";
import styles from "./ToastMessageContainer.module.css";

/**
 * @deprecated - switch to ToastContainer
 */
const ToastMessageContainer = () => {
  const dispatch = useDispatch();
  const { type, message, timeout, dismissible } = useSelector(getHttpMessageData);
  const [isUnloading, setIsUnloading] = useState(false);
  const close = useCallback(() => setIsUnloading(true), []);

  // trying to fix NetworkError when attempting to fetch resource exception when redirecting in Firefox
  useBeforeUnload(close);

  const handleClose = useCallback(() => {
    dispatch(clearHttpMessages());
  }, [dispatch]);

  if (!message || !type || Angie.app_reloading || isUnloading) {
    return null;
  }

  return (
    <Portal>
      <ToastMessage
        type={type}
        text={message}
        onClose={handleClose}
        timeout={timeout}
        dismissible={dismissible}
        className={styles.position}
        style={{
          zIndex: layers.cloud,
        }}
      />
    </Portal>
  );
};

export default ToastMessageContainer;
